import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';

import { useAppDispatch, useAppSelector } from '@shared/hooks';
import type { Product } from '@shared/types/products';

const productAdapter = createEntityAdapter<Product>({});

const productSlice = createSlice({
	name: 'product',
	initialState: productAdapter.getInitialState(),
	reducers: {
		productAdd: productAdapter.addOne,
	},
});

export const productReducer = productSlice.reducer;
export const productActions = productSlice.actions;

export const productSelectors = productAdapter.getSelectors();

export const useProduct = (id: number) => {
	const dispatch = useAppDispatch();

	const product = useAppSelector((state) => productSelectors.selectById(state.product, id));

	const addProduct = (product: Product) => dispatch(productActions.productAdd(product));

	return {
		product,
		addProduct,
	};
};
